module.exports = __webpack_public_path__ + "static/img/balancesuccess.8fd8ca91.png";